// Opens the theme's existing cart drawer after any /cart/add succeeds.
// Works with normal product forms and many "quick add" buttons.

(function () {
  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  // Helper: click the header cart button that already has on:click="/open"
  function openDrawerByButton() {
    const btn =
      document.querySelector('cart-drawer-component button[on\\:click="/open"]')
      || document.querySelector('button[on\\:click="/open"]');
    if (btn) btn.click();
  }

  // Fallback: dispatch the "open" event the component listens for
  function openDrawerByEvent() {
    const el = document.querySelector('cart-drawer-component');
    if (el) el.dispatchEvent(new CustomEvent('open', { bubbles: true }));
  }

  function openDrawer() {
    // try button click first (most reliable)
    openDrawerByButton();
    // also fire event as a backup
    openDrawerByEvent();
  }

  // Intercept standard product forms posting to /cart/add
  function wireFormIntercept() {
    document.addEventListener('submit', async function (e) {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;

      const action = (form.getAttribute('action') || '').replace(location.origin, '') || '/cart/add';
      if (!/\/cart\/add(\.js)?$/.test(action)) return;

      e.preventDefault();

      try {
        const fd = new FormData(form);
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: fd,
          headers: { Accept: 'application/json' }
        });
        if (!res.ok) {
          const j = await res.json().catch(() => ({}));
          throw new Error(j.description || j.message || 'Add to cart failed');
        }
        // open the drawer
        openDrawer();
        // optional: let other scripts update counts
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } catch (err) {
        console.error('[AddToCart] ', err);
        alert(err.message || 'Add to cart failed');
      }
    });
  }

  // Intercept "quick add" buttons that don’t submit a form
  function wireQuickAdd() {
    document.addEventListener('click', async function (e) {
      const btn = e.target.closest('[data-add-to-cart][data-variant-id]');
      if (!btn) return;

      e.preventDefault();
      try {
        const fd = new FormData();
        fd.set('id', btn.getAttribute('data-variant-id'));
        fd.set('quantity', btn.getAttribute('data-qty') || '1');

        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: fd,
          headers: { Accept: 'application/json' }
        });
        if (!res.ok) {
          const j = await res.json().catch(() => ({}));
          throw new Error(j.description || j.message || 'Add to cart failed');
        }
        openDrawer();
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } catch (err) {
        console.error('[QuickAdd] ', err);
        alert(err.message || 'Add to cart failed');
      }
    });
  }

  onReady(function () {
    wireFormIntercept();
    wireQuickAdd();
    // quick console helper (for testing)
    window.OPEN_DRAWER = openDrawer;
  });
})();
